import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

const state = {
    isLoading: false,
    inView: {},

    next: {},
    previous: {},

    cache: {}
};

export {
    actions,
    getters,
    mutations,
    state
}